import { useLocalStorage } from '@upheal/utils/hooks/useLocalStorage';
import { useCallback, useMemo } from 'react';
import { DateTime } from 'luxon';

export const LAST_SIGNED_IN_KEY = 'LAST_SIGNED_IN';

export const useLastSignedIn = () => {
    const [lastSignedIn, setLastSignedIn] = useLocalStorage<string | undefined>(
        LAST_SIGNED_IN_KEY,
        undefined,
    );

    const handleSetLastSignedIn = useCallback(() => {
        setLastSignedIn(DateTime.now().toISO());
    }, [setLastSignedIn]);

    const lastSignedInDateTime = useMemo(
        () => (lastSignedIn ? DateTime.fromISO(lastSignedIn) : undefined),
        [lastSignedIn],
    );

    return {
        lastSignedIn: lastSignedInDateTime,
        setLastSignedIn: handleSetLastSignedIn,
    };
};
